module.exports = __webpack_public_path__ + "static/media/agenda-sent-form.a5e60b58.svg";